import { useState, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import { useResizeDetector } from "react-resize-detector";
import { Box, Stack, Typography as T } from "@mui/material";
import useSWR from "swr";
import HeaderLogo from "~/components/HeaderLogo";

// Workaround for avoiding terminated pdfjs worker when reloading documents
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const pdfFetcher = async (url: string) => {
  const res = await fetch(url);

  if (!res.ok) {
    const error: any = new Error();
    const resp = await res.json();
    error.message = JSON.stringify(resp);
    error.status = res.status;
    throw error;
  }

  return res.blob();
};

const PrivacyPolicy = () => {
  const [numPages, setNumPages] = useState<null | number>(null);
  const { data } = useSWR(`/assets/privacy.pdf`, pdfFetcher, {
    revalidateOnFocus: false,
  });

  const containerRef = useRef<HTMLDivElement>(null);
  const { width } = useResizeDetector({
    targetRef: containerRef,
    handleWidth: true,
  });

  return (
    <Stack
      height="100vh"
      overflow="scroll"
      bgcolor="common.white"
      alignItems="center"
      pt={10}
      minWidth={500}
    >
      <HeaderLogo />
      <T variant="h4" component="h1" fontWeight={600} zIndex={1}>
        Privacy Policy
      </T>
      <Box ref={containerRef} width="100%" maxWidth={1000}>
        <Document
          file={data}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          noData={<></>}
          loading={<></>}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              width={width || undefined}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              renderAnnotationLayer={false}
              noData={<></>}
              loading={<></>}
            />
          ))}
        </Document>
      </Box>
    </Stack>
  );
};

export default PrivacyPolicy;
